import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import AuditLog from './AuditLog';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Admin Activity Log | Admin',
    component: (
      <AdminLayout>
        <AuditLog />
      </AdminLayout>
    ),
  };
}

export default action;
